module.exports = __webpack_public_path__ + "HP_Latex.png?edbdc8a02b4b96ee5a4e53d75473106e";